import { Link, LinkProps } from "react-router-dom";

export function ConditionalLink({ disabled = false, children, ...props }: LinkProps & { disabled?: boolean }) {
  return disabled ? <>{children}</> : <Link {...props}>{children}</Link>;
}
